/*
  Back-End page for FullStack.cash
*/

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Container, Row, Col, Card, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import backend from '../assets/images/back-end.jpg'

function BackEnd () {
  return (
    <>
      <Helmet>
        <title>Back-End Dev | FullStack.cash</title>
      </Helmet>

      <Container className='py-5'>
        <Row className='mb-5'>
          <Col md={6}>
            <h2>
              Back End: Docker Containers
              <br /> and DevOps
            </h2>
            <p>
              The 'back end' of the Cash Stack is concerned with the REST API
              layer and all the layers below it. This software has been
              conveniently packaged in Docker containers that can mount
              pre-synced databases. The pre-synced databases can be downloaded
              over IPFS from from the <Link to='/cashstrap'>Cash Strap page</Link>
              .
            </p>
            <div className='text-center'>
              <Button as={Link} to='/cashstrap' variant='primary'>
                CashStrap
              </Button>
            </div>
          </Col>
          <Col md={6}>
            <img src={backend} alt='Back End' className='img-fluid' />
          </Col>
        </Row>

        <Row>
          <Col>
            <h2 className='text-center mb-4'>Back-End Software</h2>
            <p className='text-center mb-4'>
              The software repositories below are used to create Docker
              containers for running the back-end infrastructure of the Cash
              Stack. They can be used to mount the pre-synced databases,
              downloadable from IPFS via the{' '}
              <Link to='/cashstrap'>Cash Strap page</Link>.
            </p>
            <p className='text-center mb-4'>
              The software below is complex. We try to simplify it by using
              Docker containers, but the learning curve can be rough.{' '}
              <Link to='/pricing'>
                FullStack.cash offers access to hosted infrastructure
              </Link>
              , but FullStack.cash is not a 'walled garden'. We offer the
              software below for anyone who wants to run their own
              infrastructure.
            </p>
          </Col>
        </Row>

        <Row className='g-4'>
          <Col md={6}>
            <Card className='h-100'>
              <Card.Body>
                <Card.Title><strong>bch-api REST API</strong></Card.Title>
                <Card.Text>
                  A REST API based on node.js and the Express.js framework. It
                  abstracts the full node and indexer layers into a single common
                  REST interface.
                </Card.Text>
                <div className='d-flex gap-2'>
                  <Button
                    href='https://github.com/Permissionless-Software-Foundation/bch-api'
                    target='_blank'
                    rel='noreferrer'
                    variant='outline-primary'
                  >
                    Code
                  </Button>
                  <Button
                    href='https://api.fullstack.cash/docs/'
                    target='_blank'
                    rel='noreferrer'
                    variant='outline-primary'
                  >
                    Docs
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default BackEnd
